import { useState, useCallback } from 'react';

const useConnect = () => {
  const [hide, setHide] = useState<boolean>(false);

  const toggleDropdown = useCallback(() => setHide(!hide), [setHide, hide]);

  return {
    hide,
    toggleDropdown,
  };
};

export default useConnect;
